import {
  getUser,
  isAuthenticated,
  isRestrictedApplication,
  isAuthorized,
} from './util'

export default (store, { appId }) => ({
  root(nextState, replace, callback) {
    const { pathname } = nextState.location
    const user = getUser()
    const authenticated = isAuthenticated()

    if (authenticated) {
      if (shouldRedirectToVerifyEmail(user, pathname)) {
        replace('/verify-email')
      } else if (shouldRedirectToAppRoot(user, pathname)) {
        if (shouldRedirectToAccessRestricted({ appId, user, pathname })) {
          replace(`/${appId}/access-restricted`)
        } else {
          redirectToAppRoot(replace, appId)
        }
      }
    } else if (shouldRedirectToLogin(authenticated, pathname)) {
      replace(conditionallyAddRedirectPath(pathname, '/login'))
    }

    callback()
  },

  requireAuth(nextState, replace, callback) {
    const { pathname } = nextState.location
    const user = getUser()
    const authenticated = isAuthenticated()

    if (shouldRedirectToLogin(authenticated, pathname)) {
      replace(conditionallyAddRedirectPath(pathname, '/login'))
    } else if (shouldRedirectToVerifyEmail(user, pathname)) {
      replace('/verify-email')
    } else if (shouldRedirectToAppRoot(user, pathname)) {
      redirectToAppRoot(replace, appId)
    } else if (shouldRedirectToAccessRestricted({ appId, user, pathname })) {
      replace(`/${appId}/access-restricted`)
    }

    callback()
  },
})

export function conditionallyAddRedirectPath(currentPathname = '/', to) {
  const test = /undefined?|second-factor|login|verify-(email|token)|password|register/i

  if (test.test(currentPathname)) {
    return to
  }

  return `${to}?redirectPath=${currentPathname}`
}

export function shouldRedirectToLogin(authenticated, pathname) {
  return (
    !authenticated && !/login|password|verify-token|register/i.test(pathname)
  )
}

export function shouldRedirectToVerifyEmail(user, pathname) {
  return !user.verified && !/verify-(email|token)|login/i.test(pathname)
}

export function shouldRedirectToAppRoot(user, pathname) {
  return (
    user.authenticated &&
    user.verified &&
    /verify-(email|token)|login|second-factor/i.test(pathname)
  )
}

export function redirectToAppRoot(replace, appId) {
  if (appId) {
    replace(`/${appId}`)
  }
}

export function shouldRedirectToAccessRestricted({ appId, user, pathname }) {
  return (
    isRestrictedApplication(appId) &&
    !isAuthorized({ appId, user, pathname }) &&
    !/access-restricted/.test(pathname)
  )
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/routeHooks.js